import { money } from '@nuts/auto-delivery-sdk/dist/utils/format';

export default money;
